
import React from "react";

const EmptyMessageState = () => {
  return (
    <div className="text-center py-8 border border-dashed rounded-md">
      <p className="text-gray-500">Nenhuma mensagem automática configurada</p>
      <p className="text-sm text-gray-400 mt-2">Clique no botão acima para adicionar sua primeira mensagem</p>
    </div>
  );
};

export default EmptyMessageState;
